<div class="container">
  <div class="page-header-row d-flex flex-wrap justify-content-between align-items-center gap-3 py-3">
    <div class="d-flex align-items-baseline flex-wrap gap-2">
      <h4 class="page-title mb-0">Create Package</h4>
      <span class="package-number-badge">{{ packageNumber }}</span>
    </div>
    <div
      class="d-flex align-items-center flex-wrap gap-3"
      *ngIf="
        !(
          user.specialRoleAccess &&
          user.specialRoleAccess.includes('CannotViewDealerBalance')
        )
      "
    >
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">Balance:</span>
        <span class="badge bg-success fs-6 px-3 py-2">
          {{ dealer.dealerBalance }}
        </span>
      </div>
      <button
        class="btn btn-success"
        type="button"
        (click)="paymentGatewayShowToggle()"
        *ngIf="showPaymentButton"
      >
        <i class="fa fa-plus me-1"></i>Add Money
      </button>
      <div class="w-100" *ngIf="showPaymentGatewayForm">
        <app-dealer-payment-gateway></app-dealer-payment-gateway>
      </div>
    </div>
  </div>
</div>
<br />
<nav aria-label="breadcrumb">
  <ol class="breadcrumb section-header-breadcrumb">
    <li
      class="breadcrumb-item active"
      aria-current="page"
    >
    <div class="breadcrumb-content">
      <i class="fa fa-car breadcrumb-icon"></i>
      <p class="h5 breadcrumb-text">Vehicle Details</p>
    </div>
    </li>
  </ol>
</nav>
<form [formGroup]="certficateForm" (ngSubmit)="onSubmit()">
<div *ngIf="canInvoiceAutoFill" class="card shadow-sm border-0 mb-4">
  <div class="card-header bg-primary text-white d-flex align-items-center">
    <i class="fa fa-file-pdf-o me-2"></i>
    <h6 class="mb-0">Smart Form Filler - Upload PDF</h6>
    <span class="badge bg-light text-primary ms-auto">Auto-populate</span>
  </div>
  <div class="card-body">
    <div class="alert alert-info py-2 mb-2 small">
      <i class="fa fa-info-circle me-1"></i>
      <strong>Note:</strong> Upload a <strong>dealer invoice PDF</strong> — AI will read it, auto-populate the vehicle details it can find and attach it as the Invoice Upload.
    </div>
    <div class="border rounded p-2" [class.border-primary]="isInvoiceDragOver"
         (drop)="onInvoiceDrop($event)" (dragover)="onInvoiceDragOver($event)" (dragleave)="isInvoiceDragOver = false">
      <span class="me-2 small"><i class="fa fa-file-pdf-o text-primary me-1"></i>Upload PDF Document:</span>
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="invoiceInput.click()">
        <i class="fa fa-folder-open me-1"></i>Choose File
      </button>
      <small *ngIf="selectedInvoiceName" class="ms-2">{{ selectedInvoiceName }}</small>
      <small class="text-muted d-block mt-1">PDF files only | Max size: 10MB | or drag and drop the file here</small>
    </div>
      <div *ngIf="canInvoiceAutoFill" class="small mt-2" aria-live="polite">
        <span *ngIf="invoiceExtractStatus === 'loading'" class="text-muted">
          <span class="spinner-border spinner-border-sm me-1"></span>Reading invoice to auto-fill vehicle details…
        </span>
        <span *ngIf="invoiceExtractStatus === 'error'" class="text-danger">{{ invoiceExtractMessage }}</span>
        <div *ngIf="invoiceExtractStatus === 'done'" class="text-success">
          Auto-filled: {{ invoiceApplied.length ? invoiceApplied.join(', ') : 'nothing new' }}. Please review before continuing.
        </div>
        <div *ngFor="let c of invoiceConflicts" class="text-warning">
          {{ c.label }}: invoice says "{{ c.value }}" (kept your entry).
          <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="useExtractedValue(c)">Use invoice value</button>
        </div>
      </div>
  </div>
</div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="type" class="form-label">Type</label>
      <select
        class="form-select"
        formControlName="type"
        [ngClass]="{ 'is-invalid': submitted && f.type.errors }"
        aria-describedby="typeError"
      >
        <option *ngFor="let type of types" [ngValue]="type">
          {{ type }}
        </option>
      </select>
      <div *ngIf="submitted && f.type.errors" class="invalid-feedback" id="typeError">
        <div *ngIf="f.type.errors.required">Type is required</div>
      </div>
    </div>

    <div class="mb-3 col">
      <label for="vehicleMake" class="form-label">Make</label>
      <select
        class="form-select"
        formControlName="vehicleMake"
        [ngClass]="{ 'is-invalid': submitted && f.vehicleMake.errors }"
        aria-describedby="vehicleMakeError"
      >
        <option
          *ngFor="let vehicleMake of makeModel"
          [ngValue]="vehicleMake.make"
        >
          {{ vehicleMake.make }}
        </option>
      </select>
      <div
        *ngIf="f.vehicleMake.dirty && f.vehicleMake.errors"
        class="invalid-feedback"
        id="vehicleMakeError"
      >
        <div *ngIf="f.vehicleMake.errors.required">
          Make needs to be selected
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="model" class="form-label">Model</label>
      <select
        class="form-select"
        formControlName="model"
        [ngClass]="{ 'is-invalid': submitted && f.model.errors }"
        aria-describedby="modelError"
      >
        <option *ngFor="let model of models" [ngValue]="model">
          {{ model }}
        </option>
      </select>
      <div *ngIf="submitted && f.model.errors" class="invalid-feedback" id="modelError">
        <div *ngIf="f.model.errors.required">Model is required</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="variant" class="form-label">Variant</label>
      <input
        type="text"
        formControlName="variant"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.variant.errors }"
        aria-describedby="variantError"
      />
      <div *ngIf="f.variant.dirty && f.variant.errors" class="invalid-feedback" id="variantError">
        <div *ngIf="f.variant.errors.required">Variant is required</div>
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="vehicleYear" class="form-label">Manufacturing Year</label>
      <select
        class="form-select"
        formControlName="vehicleYear"
        [ngClass]="{ 'is-invalid': submitted && f.vehicleYear.errors }"
        aria-describedby="vehicleYearError"
      >
        <option *ngFor="let vehicleYear of years" [ngValue]="vehicleYear">
          {{ vehicleYear }}
        </option>
      </select>
      <div *ngIf="submitted && f.vehicleYear.errors" class="invalid-feedback" id="vehicleYearError">
        <div *ngIf="f.vehicleYear.errors.required">
          Manufacturing year is required
        </div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="f.type.value =='Old'">
      <label for="vehicleRegistrationDate" class="form-label">Vehicle Registration Date</label>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="vehicleRegistrationDate"
          placeholder="DD/MM/YYYY"
          [minDate]="minRegistrationDateModel"
          [maxDate]="maxRegistrationDateModel"
          ngbDatepicker
          #d4="ngbDatepicker"
          [ngClass]="{ 'is-invalid': submitted && f.vehicleRegistrationDate.errors }"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d4.toggle()"
            type="button"
          ></button>
        </div>
      </div>
      <div
        *ngIf="submitted && f.vehicleRegistrationDate.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.vehicleRegistrationDate.errors.required">
          Vehicle Registration Date is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="registrationNumber" class="form-label">Registration Number</label>
      <input
        type="text"
        formControlName="registrationNumber"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.registrationNumber.errors }"
        aria-describedby="registrationNumberError"
      />
      <div
        *ngIf="submitted && f.registrationNumber.errors"
        class="invalid-feedback"
        id="registrationNumberError"
      >
        <div *ngIf="f.registrationNumber.errors.required">
          Registration Number is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="chasisNumber" class="form-label">Chasis Number</label>
      <input
        type="text"
        formControlName="chasisNumber"
        class="form-control"
        [ngClass]="{
          'is-invalid':
            (f.chasisNumber.touched || submitted) && f.chasisNumber.errors
        }"
        aria-describedby="chasisNumberError"
      />
      <div *ngIf="f.chasisNumber.errors" class="invalid-feedback" id="chasisNumberError">
        <div *ngIf="f.chasisNumber.errors.required">
          Chasis Number is required
        </div>
        <div *ngIf="f.chasisNumber.errors.minlength">
          Invalid Chasis Number!!! Chasis Number should be minimum of 17
          characters. If shorter please add zeroes ('0's) before it.
        </div>
        <div *ngIf="f.chasisNumber.errors.maxlength">
          Invalid Chasis Number!!! Chasis Number should be maximum of 17
          characters. If shorter please remove zeroes ('0's) before it.
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="engineNumber" class="form-label">Engine Number</label>
      <input
        type="text"
        formControlName="engineNumber"
        class="form-control"
        [ngClass]="{
          'is-invalid':
            (f.engineNumber.touched || submitted) && f.engineNumber.errors
        }"
        aria-describedby="engineNumberError"
      />
      <div *ngIf="f.engineNumber.errors" class="invalid-feedback" id="engineNumberError">
        <div *ngIf="f.engineNumber.errors.required">
          Engine Number is required
        </div>
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="rto" class="form-label">RTO code</label>
      <select
        class="form-select"
        formControlName="rto"
        [ngClass]="{ 'is-invalid': submitted && f.rto.errors }"
        aria-describedby="rtoError"
      >
        <option *ngFor="let rtoVal of rtoList" [ngValue]="rtoVal">
          {{ rtoVal }}
        </option>
      </select>
      <div *ngIf="submitted && f.rto.errors" class="invalid-feedback" id="rtoError">
        <div *ngIf="f.rto.errors.required">RTO is required</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="hypothecated" class="form-label">Hypothecated Vehicle</label>
      <div class="row">
        <div class="col">
          <input
            type="radio"
            formControlName="hypothecated"
            [value]="'Yes'"
            [ngClass]="{ 'is-invalid': submitted && f.hypothecated.errors }"
          />
          <span class="ms-2">Yes</span>
        </div>
        <div class="col">
          <input
            type="radio"
            formControlName="hypothecated"
            [value]="'No'"
            [ngClass]="{ 'is-invalid': submitted && f.hypothecated.errors }"
          />
          <span class="ms-2">No</span>
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="clientType" class="form-label">Client Type</label>
      <select
        class="form-select"
        formControlName="clientType"
        [ngClass]="{ 'is-invalid': submitted && f.clientType.errors }"
        aria-describedby="clientTypeError"
      >
        <option *ngFor="let clientType of clientTypes" [ngValue]="clientType">
          {{ clientType }}
        </option>
      </select>
      <div *ngIf="submitted && f.clientType.errors" class="invalid-feedback" id="clientTypeError">
        <div *ngIf="f.clientType.errors.required">
          Client Type needs to be selected
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="vehicleColor" class="form-label">Vehicle Color</label>
      <input
        type="text"
        formControlName="vehicleColor"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.vehicleColor.errors }"
      />
    </div>

  </div>
  <div class="row g-3" *ngIf="f.hypothecated.value != 'No'">
    <div class="mb-3 col">
      <label for="financeCompanyName" class="form-label">Finance Company Name</label>
      <select
        class="form-select"
        formControlName="financeCompanyName"
        [ngClass]="{ 'is-invalid': submitted && f.financeCompanyName.errors }"
        aria-describedby="financeCompanyNameError"
      >
        <option
          *ngFor="let finCompany of financeCompanies"
          [ngValue]="finCompany"
        >
          {{ finCompany }}
        </option>
      </select>

      <div
        *ngIf="submitted && f.financeCompanyName.errors"
        class="invalid-feedback"
        id="financeCompanyNameError"
      >
        <div *ngIf="f.financeCompanyName.errors.required">
          Finance Company Name is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="financeCompanyAddress" class="form-label">Finance Company Address</label>
      <input
        type="text"
        formControlName="financeCompanyAddress"
        class="form-control"
        [ngClass]="{
          'is-invalid': submitted && f.financeCompanyAddress.errors
        }"
      />
      <div
        *ngIf="submitted && f.financeCompanyAddress.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.financeCompanyAddress.errors.required">
          Finance Company Address is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="financeCompanyState" class="form-label">Finance State</label>
      <select
        class="form-select"
        formControlName="financeCompanyState"
        [ngClass]="{ 'is-invalid': submitted && f.financeCompanyState.errors }"
        aria-describedby="financeCompanyStateError"
      >
        <option *ngFor="let finstate of stateCity" [ngValue]="finstate.state">
          {{ finstate.state }}
        </option>
      </select>
      <div
        *ngIf="submitted && f.financeCompanyState.errors"
        class="invalid-feedback"
        id="financeCompanyStateError"
      >
        <div *ngIf="f.financeCompanyState.errors.required">
          Finance State needs to be selected
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="financeCompanyCity" class="form-label">City</label>
      <select
        class="form-select"
        formControlName="financeCompanyCity"
        [ngClass]="{ 'is-invalid': submitted && f.financeCompanyCity.errors }"
        aria-describedby="financeCompanyCityError"
      >
        <option *ngFor="let fincity of finCities" [ngValue]="fincity">
          {{ fincity }}
        </option>
      </select>
      <div
        *ngIf="submitted && f.financeCompanyCity.errors"
        class="invalid-feedback"
        id="financeCompanyCityError"
      >
        <div *ngIf="f.financeCompanyCity.errors.required">City is required</div>
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="invoiceFile" class="form-label" *ngIf="f.oldValueType.value == 'Invoice'">Invoice Upload</label>
      <label for="invoiceFile" class="form-label" *ngIf="f.oldValueType.value != 'Invoice'">Previous Policy</label>
      <input
        #invoiceInput
        type="file"
        (change)="onInvoiceFileSelected($event)"
        formControlName="invoiceFile"
        accept="image/*,application/pdf"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.invoiceFile.errors }"
        aria-describedby="invoiceFileError"
      />
      <div *ngIf="submitted && f.invoiceFile.errors" class="invalid-feedback" id="invoiceFileError">
        <div *ngIf="f.invoiceFile.errors.required">
          Invoice File is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="invoiceValue" class="form-label" *ngIf="f.oldValueType.value == 'Invoice'">Invoice Value</label>
      <label for="invoiceValue" class="form-label" *ngIf="f.oldValueType.value != 'Invoice'">Previous Policy IDV</label>
      <input
        type="number"
        formControlName="invoiceValue"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.invoiceValue.errors }"
        aria-describedby="invoiceValueError"
      />
      <div *ngIf="submitted && f.invoiceValue.errors" class="invalid-feedback" id="invoiceValueError">
        <div *ngIf="f.invoiceValue.errors.required">
          Invoice Value is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="cubicCapacity" class="form-label">Cubic Capacity</label>
      <input
        type="number"
        formControlName="cubicCapacity"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.cubicCapacity.errors }"
        aria-describedby="cubicCapacityError"
      />
      <div *ngIf="submitted && f.cubicCapacity.errors" class="invalid-feedback" id="cubicCapacityError">
        <div *ngIf="f.cubicCapacity.errors">
          Cubic Capacity is required and greater than zero
        </div>
      </div>
    </div>
  </div>

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb section-header-breadcrumb">
      <li
        class="breadcrumb-item active"
        aria-current="page"
      >
      <div class="breadcrumb-content">
        <i class="fa fa-book breadcrumb-icon"></i>
        <p class="h5 breadcrumb-text">Package Details</p>
        </div>
      </li>
    </ol>
  </nav>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="packageId" class="form-label">Coverage</label>
      <select
        class="form-select"
        formControlName="packageId"
        [ngClass]="{ 'is-invalid': submitted && f.packageId.errors }"
        aria-describedby="packageIdError"
      >
        <option
          *ngFor="let packag of selectedPackages"
          [ngValue]="packag.packageId"
        >
          {{ packag.packageName }}
        </option>
      </select>
      <div *ngIf="submitted && f.packageId.errors" class="invalid-feedback" id="packageIdError">
        <div *ngIf="f.packageId.errors.required">Coverage is required</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="idv" class="form-label">Insured Declared Value (IDV)</label>
      <input
        type="number"
        formControlName="idv"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.idv.errors }"
        aria-describedby="idvError"
      />
      <div *ngIf="submitted && f.idv.errors" class="invalid-feedback" id="idvError">
        <div *ngIf="f.idv.errors.required">IDV is required</div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="f.type.value == 'Old'">
      <label for="prevPolicyExpire" class="form-label">Previous Policy Expired</label>
      <select
        class="form-select"
        formControlName="prevPolicyExpire"
        [ngClass]="{ 'is-invalid': submitted && f.prevPolicyExpire.errors }"
        aria-describedby="prevPolicyExpireError"
      >
        <option
          *ngFor="let prevPolExpire of policyExpireArray"
          [ngValue]="prevPolExpire"
        >
          {{ prevPolExpire }}
        </option>
      </select>
      <div
        *ngIf="submitted && f.prevPolicyExpire.errors"
        class="invalid-feedback"
        id="prevPolicyExpireError"
      >
        <div *ngIf="f.prevPolicyExpire.errors.required">
          Previous Policy Expired is required
        </div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="dealarConfigFound || f.type.value == 'Old'">
      <label for="packagePolicyTotalAmount" class="form-label">Estimated Insurance Amount</label>
      <input
        type="number"
        formControlName="packagePolicyTotalAmount"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.idv.errors }"
      />
    </div>
  </div>
  <div class="row g-3" *ngIf="f.prevPolicyExpire.value == policyExpireArray[2] || f.prevPolicyExpire.value == policyExpireArray[3]">
    <div class="mb-3 col">
      <label for="breakInspectionReportNumber" class="form-label">Inspection Report#</label>
      <input
        type="text"
        formControlName="breakInspectionReportNumber"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.breakInspectionReportNumber.errors }"
        aria-describedby="breakInspectionReportNumberError"
      />
      <div *ngIf="submitted && f.breakInspectionReportNumber.errors" class="invalid-feedback" id="breakInspectionReportNumberError">
        <div *ngIf="f.breakInspectionReportNumber.errors.required">Inspection Report Number is required</div>
        <div *ngIf="f.breakInspectionReportNumber.errors.pattern">Please enter correct inspection case id</div>
      </div>
    </div>

    <div class="mb-3 col">
      <label for="breakInspectionReportDate" class="form-label">Inspection Date</label>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="breakInspectionReportDate"
          placeholder="DD/MM/YYYY"
          ngbDatepicker
          #break="ngbDatepicker"
          [ngClass]="{ 'is-invalid': submitted && f.breakInspectionReportDate.errors }"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="break.toggle()"
            type="button"
          ></button>
        </div>
        <div *ngIf="submitted && f.breakInspectionReportDate.errors" class="invalid-feedback">
          <div>
            Break Inspection Report Date is required 
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="breakInspectionReportTimeHH" class="form-label">Inspection Time</label>
      <div class="time-input">
        <div class="time-select">
          <select
            class="form-select"
            formControlName="breakInspectionReportTimeHH"
            [ngClass]="{ 'is-invalid': submitted && f.breakInspectionReportTimeHH.errors }"
          >
            <option value="" disabled selected>HH</option>
            <option *ngFor="let hour of hours" [ngValue]="hour">
              {{ hour }}
            </option>
          </select>
          <div *ngIf="submitted && f.breakInspectionReportTimeHH.errors" class="invalid-feedback">
            <div>Break Inspection Report Time is required</div>
          </div>
        </div>
        <span class="time-separator">:</span>
        <div class="time-select">
          <select
            class="form-select"
            formControlName="breakInspectionReportTimeMM"
            [ngClass]="{ 'is-invalid': submitted && f.breakInspectionReportTimeMM.errors }"
          >
            <option value="" disabled selected>MM</option>
            <option *ngFor="let minute of minutes" [ngValue]="minute">
              {{ minute }}
            </option>
          </select>
          <div *ngIf="submitted && f.breakInspectionReportTimeMM.errors" class="invalid-feedback">
            <div>Break Inspection Report Time is required</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="breakInspectionReportFile" class="form-label">Break Inspection File Upload</label>
      <input
        type="file"
        (change)="onBreakInspectionReportFileSelected($event)"
        formControlName="breakInspectionReportFile"
        accept="image/*,application/pdf"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.breakInspectionReportFile.errors }"
        aria-describedby="breakInspectionReportFileError"
      />
      <div *ngIf="submitted && f.breakInspectionReportFile.errors" class="invalid-feedback" id="breakInspectionReportFileError">
        <div *ngIf="f.breakInspectionReportFile.errors.required">
          Break Inspection File is required
        </div>
      </div>
    </div>

  </div>

  <div class="row g-3">
    <div class="mb-3 col" *ngIf="vehicleAge <= 5">
      <label for="nilDep" class="form-label">Nil Depreciation</label>
      <div class="row">
        <div class="col">
          <input
            type="radio"
            formControlName="nilDep"
            id="nilDep"
            [value]="'Yes'"
            [ngClass]="{ 'is-invalid': submitted && f.nilDep.errors }" 
          />
          <span class="ms-2">Yes</span>
        </div>
        <div class="col">
          <input
            type="radio"
            formControlName="nilDep"
            id="nilDep"
            [value]="'No'"
            [ngClass]="{ 'is-invalid': submitted && f.nilDep.errors }"
          />
          <span class="ms-2">No</span>
        </div>
      </div>
      <div *ngIf="submitted && f.nilDep.errors" class="invalid-feedback">
        <div *ngIf="f.nilDep.errors.required">Nil Depreciation is required</div>
      </div>
    </div>
        <div class="mb-3 col" *ngIf="vehicleAge <= 5">
            <label for="rtiCover" class="form-label">Return To Invoice Cover</label>
            <div class="row">
              <div class="col">
                <input
                  type="radio"
                  formControlName="rtiCover"
                  id="rtiCover"
                  [value]="'Yes'"
                  [ngClass]="{ 'is-invalid': submitted && f.rtiCover.errors }" 
                />
                <span class="ms-2">Yes</span>
              </div>
              <div class="col">
                <input
                  type="radio"
                  formControlName="rtiCover"
                  id="rtiCover"
                  [value]="'No'"
                  [ngClass]="{ 'is-invalid': submitted && f.rtiCover.errors }"
                />
                <span class="ms-2">No</span>
              </div>
            </div>
            <div *ngIf="submitted && f.rtiCover.errors" class="invalid-feedback">
              <div *ngIf="f.rtiCover.errors.required">RTI Cover is required</div>
            </div>
      
    </div>
    <div class="mb-3 col" *ngIf="selectedPackage && selectedPackage.tpApplicable">
</div>
<div class="mb-3 col"></div>
</div>

  <div class="row g-3">
    <div class="mb-3 col">
      <label for="startDate" class="form-label">Risk Start Date</label>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="startDate"
          placeholder="DD/MM/YYYY"
          [minDate]="startDateModel"
          ngbDatepicker
          #d1="ngbDatepicker"
          [ngClass]="{ 'is-invalid': submitted && f.startDate.errors }"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d1.toggle()"
            type="button"
          ></button>
        </div>
      </div>
      <div *ngIf="submitted && f.startDate.errors" class="invalid-feedback">
        <div *ngIf="f.startDate.errors.required">Start Date is required</div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="f.type.value == 'Old'">
      <label for="transferCase" class="form-label">Transfer Case?</label>
      <div class="row">
        <div class="col">
          <input
            type="radio"
            formControlName="transferCase"
            [value]="'Yes'"
            [ngClass]="{ 'is-invalid': submitted && f.transferCase.errors }"
          />
          <span class="ms-2">Yes</span>
        </div>
        <div class="col">
          <input
            type="radio"
            formControlName="transferCase"
            [value]="'No'"
            [ngClass]="{ 'is-invalid': submitted && f.transferCase.errors }"
          />
          <span class="ms-2">No</span>
        </div>
      </div>
      <div *ngIf="submitted && f.transferCase.errors" class="invalid-feedback">
        <div *ngIf="f.transferCase.errors.required">
          Transfer Case is required
        </div>
      </div>
    </div>

    <div class="mb-3 col" *ngIf="f.type.value != 'Old'"></div>
    <div class="mb-3 col" *ngIf="f.type.value != 'Old'"></div>
    <div
      class="mb-3 col"
      *ngIf="
        f.type.value == 'Old' &&
        selectPolicyExpiryClaim.includes(f.prevPolicyExpire.value)
      "
    >
      <label for="prePolClaim" class="form-label">Previous Policy Claim</label>
      <div class="row">
        <div class="col">
          <input
            type="radio"
            formControlName="prePolClaim"
            [value]="'Yes'"
            [ngClass]="{ 'is-invalid': submitted && f.prePolClaim.errors }"
          />
          <span class="ms-2">Yes</span>
        </div>
        <div class="col">
          <input
            type="radio"
            formControlName="prePolClaim"
            [value]="'No'"
            [ngClass]="{ 'is-invalid': submitted && f.prePolClaim.errors }"
          />
          <span class="ms-2">No</span>
        </div>
      </div>
      <div *ngIf="submitted && f.prePolClaim.errors" class="invalid-feedback">
        <div *ngIf="f.prePolClaim.errors.required">
          Previous Policy Claim is required
        </div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="f.prePolClaim.value == 'Yes'">
      <label for="ncbPercentValue" class="form-label">Previous Claim Year</label>
      <select
        class="form-select"
        formControlName="ncbPercentValue"
        [ngClass]="{ 'is-invalid': submitted && f.ncbPercentValue.errors }"
      >
        <option
          *ngFor="let claimBonusYear of selectedNoClaimBonusYear"
          [ngValue]="claimBonusYear.ncbPercentage"
        >
          {{ claimBonusYear.ncbYear }}
        </option>
      </select>
    </div>

    <div class="mb-3 col" *ngIf="f.type.value != 'Old'"></div>
  </div>

  <div
    class="row g-3"
    *ngIf="
      selectedPackage &&
      selectedPackage.prevInsuranceDetailShow &&
      selectedPackage.prevInsuranceDetailShow.includes('GetODDetails')
    "
  >
    <div class="mb-3 col">
      <label for="prevOdInsurer" class="form-label">Previous OD Insurer</label>
      <select
        class="form-select"
        formControlName="prevOdInsurer"
        [ngClass]="{ 'is-invalid': submitted && f.prevOdInsurer.errors }"
        aria-describedby="prevOdInsurerError"
      >
        <option *ngFor="let company of insuranceCompany" [ngValue]="company">
          {{ company }}
        </option>
      </select>
      <div *ngIf="submitted && f.prevOdInsurer.errors" class="invalid-feedback" id="prevOdInsurerError">
        <div *ngIf="f.prevOdInsurer.errors.required">
          Previous OD Insurer is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="prevOdPolicyNo" class="form-label">Previous OD Policy Number</label>
      <input
        type="text"
        formControlName="prevOdPolicyNo"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.prevOdPolicyNo.errors }"
        aria-describedby="prevOdPolicyNoError"
      />
      <div
        *ngIf="submitted && f.prevOdPolicyNo.errors"
        class="invalid-feedback"
        id="prevOdPolicyNoError"
      >
        <div *ngIf="f.prevOdPolicyNo.errors.required">
          Previous OD policy number is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="prevOdPolicyExpiry" class="form-label">Previous OD Policy Expiry Date</label>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="prevOdPolicyExpiry"
          placeholder="DD/MM/YYYY"
          [minDate]="minOdDateModel"
          [maxDate]="maxOdDateModel"
          ngbDatepicker
          #d2="ngbDatepicker"
          [ngClass]="{ 'is-invalid': submitted && f.prevOdPolicyExpiry.errors }"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d2.toggle()"
            type="button"
          ></button>
        </div>
      </div>
      <div
        *ngIf="submitted && f.prevOdPolicyExpiry.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.prevOdPolicyExpiry.errors.required">
          Previous OD Policy Expiry Date is required
        </div>
      </div>
    </div>
  </div>
  <div
    class="row g-3"
    *ngIf="
      selectedPackage &&
      selectedPackage.prevInsuranceDetailShow &&
      selectedPackage.prevInsuranceDetailShow.includes('GetTPDetails')
    "
  >
    <div class="mb-3 col">
      <label for="prevTpInsurer" class="form-label">Previous TP Insurer</label>
      <select
        class="form-select"
        formControlName="prevTpInsurer"
        [ngClass]="{ 'is-invalid': submitted && f.prevTpInsurer.errors }"
        aria-describedby="prevTpInsurerError"
      >
        <option *ngFor="let company of insuranceCompany" [ngValue]="company">
          {{ company }}
        </option>
      </select>
      <div *ngIf="submitted && f.prevTpInsurer.errors" class="invalid-feedback" id="prevTpInsurerError">
        <div *ngIf="f.prevTpInsurer.errors.required">
          Previous TP Insurer is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="prevTpPolicyNo" class="form-label">Previous TP Policy Number</label>
      <input
        type="text"
        formControlName="prevTpPolicyNo"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.prevTpPolicyNo.errors }"
        aria-describedby="prevTpPolicyNoError"
      />
      <div
        *ngIf="submitted && f.prevTpPolicyNo.errors"
        class="invalid-feedback"
        id="prevTpPolicyNoError"
      >
        <div *ngIf="f.prevTpPolicyNo.errors.required">
          Previous TP policy number is required
        </div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="prevTpPolicyExpiry" class="form-label">Previous TP Policy Expiry Date</label>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="prevTpPolicyExpiry"
          placeholder="DD/MM/YYYY"
          [minDate]="startDateModel"
          ngbDatepicker
          #d3="ngbDatepicker"
          [ngClass]="{ 'is-invalid': submitted && f.prevTpPolicyExpiry.errors }"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d3.toggle()"
            type="button"
          ></button>
        </div>
      </div>
      <div
        *ngIf="submitted && f.prevTpPolicyExpiry.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.prevTpPolicyExpiry.errors.required">
          Previous TP Policy Expiry Date is required
        </div>
      </div>
    </div>
  </div>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb section-header-breadcrumb">
      <li
        class="breadcrumb-item active"
        aria-current="page"
      >
      <div class="breadcrumb-content">
        <i class="fa fa-user breadcrumb-icon"></i>
        <p class="h5 breadcrumb-text">KYC Details</p>
        </div>
      </li>
    </ol>
  </nav>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="aadhaarNumber" class="form-label" *ngIf="!isCorporate">Aadhaar Number</label>
      <label for="aadhaarNumber" class="form-label" *ngIf="isCorporate">GST Number</label>
      <input
        type="text"
        formControlName="aadhaarNumber"
        class="form-control"
        [ngClass]="{
          'is-invalid':
            (f.aadhaarNumber.touched || submitted) && f.aadhaarNumber.errors
        }"
        aria-describedby="aadhaarNumberError"
      />
      <div
        *ngIf="f.aadhaarNumber.errors && !isCorporate"
        class="invalid-feedback"
        id="aadhaarNumberError"
      >
        <div *ngIf="f.aadhaarNumber.errors.required">
          Aadhaar Number is required
        </div>
        <div *ngIf="f.aadhaarNumber.errors.pattern">
          Aadhaar Number is invalid
        </div>
      </div>
      <div
        *ngIf="f.aadhaarNumber.errors && isCorporate"
        class="invalid-feedback"
      >
        <div *ngIf="f.aadhaarNumber.errors.required">
          GST Number is required
        </div>
        <div *ngIf="f.aadhaarNumber.errors.pattern">GST Number is invalid</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="aadhaarFile" class="form-label" *ngIf="!isCorporate">Aadhaar Upload</label>
      <label for="aadhaarFile" class="form-label" *ngIf="isCorporate">GST Upload</label>
      <input
        type="file"
        (change)="onAadhaarFileSelected($event)"
        formControlName="aadhaarFile"
        accept="image/*,application/pdf"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.aadhaarFile.errors }"
        aria-describedby="aadhaarFileError"
      />
      <div *ngIf="submitted && f.aadhaarFile.errors" class="invalid-feedback" id="aadhaarFileError">
        <div *ngIf="f.aadhaarFile.errors.required && !isCorporate">
          Aadhaar File is required
        </div>
        <div *ngIf="f.aadhaarFile.errors.required && isCorporate">
          GST File is required
        </div>
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="panNumber" class="form-label">PAN Number</label>
      <input
        type="text"
        formControlName="panNumber"
        class="form-control"
        [ngClass]="{
          'is-invalid': (f.panNumber.touched || submitted) && f.panNumber.errors
        }"
        aria-describedby="panNumberError"
      />
      <div *ngIf="f.panNumber.errors" class="invalid-feedback" id="panNumberError">
        <div *ngIf="f.panNumber.errors.required">PAN Number is required</div>
        <div *ngIf="f.panNumber.errors.pattern">PAN Number is invalid</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="panFile" class="form-label">PAN Upload</label>
      <input
        type="file"
        (change)="onPanFileSelected($event)"
        formControlName="panFile"
        accept="image/*"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.panFile.errors }"
        aria-describedby="panFileError"
      />
      <div *ngIf="submitted && f.panFile.errors" class="invalid-feedback" id="panFileError">
        <div *ngIf="f.panFile.errors.required">PAN File is required</div>
      </div>
    </div>
  </div>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb section-header-breadcrumb">
      <li
        class="breadcrumb-item active"
        aria-current="page"
      >
      <div class="breadcrumb-content">
        <i class="fa fa-user breadcrumb-icon"></i>
        <p class="h5 breadcrumb-text" *ngIf="!isCorporate">
          Customer Details
        </p>
        <p class="h5 breadcrumb-text" *ngIf="isCorporate">
          Corporate Details
        </p>
        </div>
      </li>
    </ol>
  </nav>
  <div class="row g-3">
    <div class="mb-3 col" *ngIf="!isCorporate">
      <label for="title" class="form-label">Title</label>
      <select
        class="form-select"
        formControlName="title"
        [ngClass]="{ 'is-invalid': submitted && f.title.errors }"
      >
        <option *ngFor="let title of titles" [ngValue]="title">
          {{ title }}
        </option>
      </select>
      <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
        <div *ngIf="f.title.errors.required">Title needs to be selected</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="firstName" class="form-label" *ngIf="!isCorporate">First Name</label>
      <label for="firstName" class="form-label" *ngIf="isCorporate">Organisation Name</label>
      <input
        type="text"
        formControlName="firstName"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }"
        aria-describedby="firstNameError"
      />
      <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback" id="firstNameError">
        <div *ngIf="f.firstName.errors.required">Name is required</div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="!isCorporate">
      <label for="lastName" class="form-label">Last Name</label>
      <input
        type="text"
        formControlName="lastName"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
        aria-describedby="lastNameError"
      />
      <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback" id="lastNameError">
        <div *ngIf="f.lastName.errors.required">Last Name is required</div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="isCorporate"></div>
  </div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="email" class="form-label" *ngIf="!isCorporate">Email</label>
      <label for="email" class="form-label" *ngIf="isCorporate">Organisation Email</label>
      <input
        type="text"
        formControlName="email"
        class="form-control"
        [ngClass]="{
          'is-invalid': (f.email.touched || submitted) && f.email.errors
        }"
        aria-describedby="emailError"
      />
      <div *ngIf="f.email.errors" class="invalid-feedback" id="emailError">
        <div *ngIf="f.email.errors.required">Email is required</div>
        <div *ngIf="f.email.errors.email">Email id is invalid</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="contactNumber" class="form-label"> Contact Number </label>
      <input
        type="number"
        formControlName="contactNumber"
        class="form-control"
        maxlength="10"
        [ngClass]="{
          'is-invalid':
            (f.contactNumber.touched || submitted) && f.contactNumber.errors
        }"
        aria-describedby="contactNumberError"
      />
      <div *ngIf="f.contactNumber.errors" class="invalid-feedback" id="contactNumberError">
        <div *ngIf="f.contactNumber.errors.required">
          Contact Number is required
        </div>
        <div *ngIf="f.contactNumber.errors.pattern">
          Invalid contact number. Please enter 10 digit proper mobile number
        </div>
      </div>
    </div>
  </div>
  <div class="row g-3" *ngIf="!isCorporate">
    <div class="mb-3 col">
      <label for="gender" class="form-label">Gender</label>
      <select
        class="form-select"
        formControlName="gender"
        [ngClass]="{ 'is-invalid': submitted && f.gender.errors }"
        aria-describedby="genderError"
      >
        <option *ngFor="let gender of genders" [ngValue]="gender">
          {{ gender }}
        </option>
      </select>
      <div *ngIf="submitted && f.gender.errors" class="invalid-feedback" id="genderError">
        <div *ngIf="f.gender.errors.required">Gender is required</div>
      </div>
    </div>

    <div class="mb-3 col" *ngIf="f.ageOrDob.value == ageOrDobValue[1]">
      <label for="age" class="form-label">Age</label>
      <div class="input-group">
        <input
          type="number"
          formControlName="age"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.age.errors }"
          aria-describedby="ageError"
        />
        <div *ngIf="submitted && f.age.errors" class="invalid-feedback" id="ageError">
          <div *ngIf="f.age.errors.required">Age is required</div>
          <div *ngIf="f.age.errors.max">Maximum age allowed is 80</div>
          <div *ngIf="f.age.errors.min">Minimum age allowed is 15</div>
        </div>
      </div>
    </div>
    <div class="mb-3 col" *ngIf="f.ageOrDob.value == ageOrDobValue[0]">
      <label for="dob" class="form-label">Date of Birth</label>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="dob"
          [minDate]="minDobDateModel"
          [maxDate]="maxDobDateModel"
          placeholder="DD/MM/YYYY"
          ngbDatepicker
          #d="ngbDatepicker"
          [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d.toggle()"
            type="button"
          ></button>
        </div>
        <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
          <div>
            Date of birth is required and age should be between 15 to 80 years
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="mb-3 col">
      <label for="address" class="form-label" *ngIf="!isCorporate">Address</label>
      <label for="address" class="form-label" *ngIf="isCorporate">Organisation Address</label>
      <input
        type="text"
        formControlName="address"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.address.errors }"
        aria-describedby="addressError"
      />
      <div *ngIf="submitted && f.address.errors" class="invalid-feedback" id="addressError">
        <div *ngIf="f.address.errors.required">Address is required</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="state" class="form-label">State</label>
      <select
        class="form-select"
        formControlName="state"
        [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
        aria-describedby="stateError"
      >
        <option *ngFor="let state of stateCity" [ngValue]="state.state">
          {{ state.state }}
        </option>
      </select>
      <div *ngIf="submitted && f.state.errors" class="invalid-feedback" id="stateError">
        <div *ngIf="f.state.errors.required">State needs to be selected</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="city" class="form-label">City</label>
      <select
        class="form-select"
        formControlName="city"
        [ngClass]="{ 'is-invalid': submitted && f.city.errors }"
        aria-describedby="cityError"
      >
        <option *ngFor="let city of cities" [ngValue]="city">
          {{ city }}
        </option>
      </select>
      <div *ngIf="submitted && f.city.errors" class="invalid-feedback" id="cityError">
        <div *ngIf="f.city.errors.required">City is required</div>
      </div>
    </div>
    <div class="mb-3 col">
      <label for="pincode" class="form-label">Pincode</label>
      <input
        type="number"
        formControlName="pincode"
        class="form-control"
        [ngClass]="{
          'is-invalid': (f.pincode.touched || submitted) && f.pincode.errors
        }"
        aria-describedby="pincodeError"
      />
      <div *ngIf="f.pincode.errors" class="invalid-feedback" id="pincodeError">
        <div *ngIf="f.pincode.errors.required">Pincode is required</div>
        <div *ngIf="f.pincode.errors.pattern">Pincode is invalid</div>
      </div>
    </div>
  </div>
  <div>
    <nav aria-label="breadcrumb" *ngIf="!isCorporate">
      <ol class="breadcrumb section-header-breadcrumb">
        <li
          class="breadcrumb-item active"
          aria-current="page"
        >
        <div class="breadcrumb-content">
          <i class="fa fa-user breadcrumb-icon"></i>
          <p class="h5 breadcrumb-text" *ngIf="!isCorporate">
            Nominee Details
          </p>
          <p class="h5 breadcrumb-text" *ngIf="isCorporate">
            Contact Person Details
          </p>
          </div>
        </li>
      </ol>
    </nav>
    <div class="row g-3">
      <div class="mb-3 col">
        <label for="nomineeName" class="form-label" *ngIf="!isCorporate">Nominee Name</label>
        <label for="nomineeName" class="form-label" *ngIf="isCorporate">Name</label>
        <input
          type="text"
          formControlName="nomineeName"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.nomineeName.errors }"
          aria-describedby="nomineeNameError"
        />
        <div *ngIf="submitted && f.nomineeName.errors" class="invalid-feedback" id="nomineeNameError">
          <div *ngIf="f.nomineeName.errors.required">Name is required</div>
        </div>
      </div>
      <div class="mb-3 col">
        <label for="nomineeGender" class="form-label" *ngIf="!isCorporate">Nominee Gender</label>
        <label for="nomineeGender" class="form-label" *ngIf="isCorporate">Gender</label>
        <select
          class="form-select"
          formControlName="nomineeGender"
          [ngClass]="{ 'is-invalid': submitted && f.nomineeGender.errors }"
        >
          <option
            *ngFor="let nomineeGender of genders"
            [ngValue]="nomineeGender"
          >
            {{ nomineeGender }}
          </option>
        </select>
        <div
          *ngIf="submitted && f.nomineeGender.errors"
          class="invalid-feedback"
        >
          <div *ngIf="f.nomineeGender.errors.required">Gender is required</div>
        </div>
      </div>
      <div class="mb-3 col" *ngIf="!isCorporate">
        <label for="nomineeRelationship" class="form-label">Nominee Relationship</label>
        <select
          class="form-select"
          formControlName="nomineeRelationship"
          [ngClass]="{
            'is-invalid': submitted && f.nomineeRelationship.errors
          }"
        >
          <option
            *ngFor="let nomineeRelationship of relationships"
            [ngValue]="nomineeRelationship"
          >
            {{ nomineeRelationship }}
          </option>
        </select>
        <div
          *ngIf="submitted && f.nomineeRelationship.errors"
          class="invalid-feedback"
        >
          <div *ngIf="f.nomineeRelationship.errors.required">
            Nominee Relationship is required
          </div>
        </div>
      </div>
      <div class="mb-3 col">
        <label for="nomineeAge" class="form-label" *ngIf="!isCorporate">Nominee Age</label>
        <label for="nomineeAge" class="form-label" *ngIf="isCorporate"> Age</label>
        <input
          type="number"
          formControlName="nomineeAge"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.nomineeAge.errors }"
          aria-describedby="nomineeAgeError"
        />
        <div *ngIf="submitted && f.nomineeAge.errors" class="invalid-feedback" id="nomineeAgeError">
          <div *ngIf="f.nomineeAge.errors.required">Age is required</div>
          <div *ngIf="f.nomineeAge.errors.max">Maximum age allowed is 100</div>
          <div *ngIf="f.nomineeAge.errors.min">Minimum age allowed is 1</div>
        </div>
      </div>
      <div class="mb-3 col" *ngIf="isCorporate">
        <label for="employeeContactNumber" class="form-label">Contact Number</label>
        <input
          type="number"
          formControlName="employeeContactNumber"
          class="form-control"
          maxlength="10"
          [ngClass]="{ 'is-invalid': submitted && f.contactNumber.errors }"
          aria-describedby="employeeContactNumberError"
        />
        <div
          *ngIf="submitted && f.employeeContactNumber.errors"
          class="invalid-feedback"
          id="employeeContactNumberError"
        >
          <div *ngIf="f.employeeContactNumber.errors.required">
            Contact Number is required
          </div>
          <div *ngIf="f.employeeContactNumber.errors.minlength">
            Contact Number must be at least 6 characters
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="certificateCreated">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb section-header-breadcrumb">
        <li
          class="breadcrumb-item active"
          aria-current="page"
        >
        <div class="breadcrumb-content">
          <i class="fa fa-book breadcrumb-icon"></i>
          <p class="h5 breadcrumb-text">Policy Details</p>
          </div>
        </li>
      </ol>
    </nav>
    <div class="row g-3" *ngIf="certificateCreated">
      <div class="mb-3 col">
        <label for="certificateNumber" class="form-label">Certificate</label>
        <input
          type="text"
          formControlName="certificateNumber"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.certificateNumber.errors }"
          disabled
        />
      </div>
      <div class="mb-3 col">
        <label for="policyNumber" class="form-label">Policy Number</label>
        <input
          type="text"
          formControlName="policyNumber"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.policyNumber.errors }"
          disabled
        />
      </div>
    </div>
  </div>
  <div class="mb-3">
    <button [disabled]="loading || isBalanceLow" class="btn btn-primary me-2">
      <span
        *ngIf="loading"
        class="spinner-border spinner-border-sm me-1"
      ></span>
      Save
    </button>
    <button class="btn btn-secondary me-2" type="reset" (click)="onReset()">
      New Form
    </button>
    <a routerLink="/issueCertificate" class="btn btn-link">Cancel</a>
  </div>
</form>
